function initButtonCharacterStagger() {
  const offsetIncrement = 0.01;
  const selector = '.button:not(.button-unstyled, .button-shopify-xr), .button-secondary';

  document.querySelectorAll(selector).forEach((button) => {
    // Only animate buttons with no element children (pure text, no icons)
    if (button.childElementCount > 0) return;

    const text = button.textContent.trim();
    if (!text) return;

    const wrapper = document.createElement('span');
    wrapper.setAttribute('data-button-animate-chars', '');

    [...text].forEach((char, index) => {
      const span = document.createElement('span');
      span.textContent = char;
      span.style.transitionDelay = `${index * offsetIncrement}s`;
      if (char === ' ') span.style.whiteSpace = 'pre';
      wrapper.appendChild(span);
    });

    button.textContent = '';
    button.appendChild(wrapper);
  });
}

document.addEventListener('DOMContentLoaded', initButtonCharacterStagger);

// Re-run when the Shopify Theme Editor loads a section
document.addEventListener('shopify:section:load', initButtonCharacterStagger);
